import React, { PureComponent } from 'react';
import { withStyles } from '@material-ui/core/styles';
import PropTypes from 'prop-types';
import Divider from '@material-ui/core/Divider';
import Typography from '@material-ui/core/Typography';
import { styles as InputStyles } from '@material-ui/core/Input/Input';
import ExpansionPanel from '@material-ui/core/ExpansionPanel';
import ExpansionPanelSummary from '@material-ui/core/ExpansionPanelSummary';
import ExpansionPanelDetails from '@material-ui/core/ExpansionPanelDetails';
import Button from '@material-ui/core/Button';
import { ChevronDown } from '../Icons';
import { Range } from 'rc-slider';
import { omit, merge, pick } from 'ramda';
import 'rc-slider/assets/index.css';

class AdvancedFiltersMobile extends PureComponent {
  static propTypes = {
    classes: PropTypes.object,
    filters: PropTypes.object,
    onHoleChange: PropTypes.func,
    onCartChange: PropTypes.func
  };

  state = {
      showTime: false,
      showPrice: false,
      showHoles: false,
      showCart: false
  }
  handleApply = () => {
    this.props.handleClose()
    this.props.onApplied()
  }

  handleReset = () => {
    this.props.onReset()
    this.props.handleClose()
  }

  handleExpandTime = (event, expanded) => this.setState({
    showTime: expanded
})
handleExpandPrice = (event, expanded) => this.setState({
    showPrice: expanded
})
handleExpandHoles = (event, expanded) => this.setState({
    showHoles: expanded
})

handleExpandCart = (event, expanded) => this.setState({
    showCart: expanded
})

  render() {
    const { classes, filters, onHoleChange, onCartChange, onTimeChange, onPriceRangeInputChange } = this.props;
    const { timeRange, priceRange, holeCountSelection, golfCartSelection } = filters;
    const classOverides = {
        contained: classes.buttonContained,
        root: classes.buttonRoot,
        disabled: classes.disabled
      }
    return (
      <div >
           <ExpansionPanel elevation={0} expanded={this.state.showTime} onChange={this.handleExpandTime} className={classes.expantionPanel}>
                <ExpansionPanelSummary
                    expandIcon={<ChevronDown   viewBox="0 0 24 13" className={classes.expand} />}
                    IconButtonProps={{ disableRipple: true }}
                >
                    <div>
                        <Typography className={`${classes.headers} ${classes.semiBold}`}>Time</Typography>
                        <Typography className={classes.subNoteHeader}>{`${timeRange.minSelectedFormatted} to ${timeRange.maxSelectedFormatted}`}</Typography>
                    </div>

                </ExpansionPanelSummary>
                <ExpansionPanelDetails className={classes.expansion}>
                    <Range
                        trackStyle={[{ backgroundColor: '#53a318', }, { backgroundColor: '#53a318' }]}
                        handleStyle={
                        [{ height: '30px', width: '30px', marginTop: '-13px', boxShadow: '0 1px 4px 0 rgba(0, 0, 0, 0.29)', border: '1px solid #e4e4e4' }, { height: '30px', width: '30px', marginTop: '-13px', boxShadow: '0 1px 4px 0 rgba(0, 0, 0, 0.29)', border: '1px solid #e4e4e4' }]
                        }
                        className={classes.slider}
                        min={timeRange.min}
                        max={timeRange.max}
                        onChange={onTimeChange}
                        value={[timeRange.minSelected, timeRange.maxSelected]}
                    />
                    <Typography className={classes.subNote}>{`${timeRange.minSelectedFormatted} to ${timeRange.maxSelectedFormatted}`}</Typography>
                </ExpansionPanelDetails>
            </ExpansionPanel>
            <Divider />
            <ExpansionPanel elevation={0} expanded={this.state.showPrice} onChange={this.handleExpandPrice} className={classes.expantionPanel}>
                <ExpansionPanelSummary
                    expandIcon={<ChevronDown   viewBox="0 0 24 13" className={classes.expand} />}
                    IconButtonProps={{ disableRipple: true }}
                >
                    <div>
                        <Typography className={`${classes.headers} ${classes.semiBold}`}>Price</Typography>
                        <Typography className={classes.subNoteHeader}>{`$${priceRange.minTextInput} to $${priceRange.maxTextInput}`}</Typography>
                    </div>
                </ExpansionPanelSummary>
                <ExpansionPanelDetails className={classes.expansion}>
                    <Range
                        trackStyle={[{ backgroundColor: '#53a318', }, { backgroundColor: '#53a318' }]}
                        handleStyle={
                        [{ height: '30px', width: '30px', marginTop: '-13px', boxShadow: '0 1px 4px 0 rgba(0, 0, 0, 0.29)', border: '1px solid #e4e4e4' }, { height: '30px', width: '30px', marginTop: '-13px', boxShadow: '0 1px 4px 0 rgba(0, 0, 0, 0.29)', border: '1px solid #e4e4e4' }]
                        }
                        className={classes.slider}
                        min={priceRange.min}
                        max={priceRange.max}
                        onChange={onPriceRangeInputChange}
                        value={[priceRange.minSelected, priceRange.maxSelected]}
                    />
                    <Typography className={classes.subNote}>{`$${priceRange.minTextInput} to $${priceRange.maxTextInput}`}</Typography>
                </ExpansionPanelDetails>
            </ExpansionPanel>
            <Divider />
            <ExpansionPanel elevation={0} expanded={this.state.showHoles} onChange={this.handleExpandHoles} className={classes.expantionPanel}>
                <ExpansionPanelSummary
                    expandIcon={<ChevronDown   viewBox="0 0 24 13" className={classes.expand} />}
                    IconButtonProps={{ disableRipple: true }}
                >
                    <div>
                        <Typography className={`${classes.headers} ${classes.semiBold}`}>Holes</Typography>
                        <Typography className={classes.subNoteHeader}>{holeCountSelection === '0' ? 'Any' : holeCountSelection}</Typography>
                    </div>
                </ExpansionPanelSummary>
                <ExpansionPanelDetails className={classes.expansion}>
                <div style={{ display: 'flex' }}>
                            <Button
                                onClick={() => onHoleChange({ target: { value: '0'}})}
                                variant={holeCountSelection === '0' ? 'contained' : 'flat'}
                                classes={classOverides} disabled={holeCountSelection === '0'}
                                className={`${classes.button} ${holeCountSelection === '0' ? classes.selected : ''} ${classes.unsetTextTransform}`}
                            >
                                Any
                            </Button>
                            <Button
                                onClick={() => onHoleChange({ target: { value: '9'}})}
                                variant={holeCountSelection === '9' ? 'contained' : 'flat'}
                                classes={classOverides}
                                disabled={holeCountSelection === '9'}
                                className={`${classes.button} ${holeCountSelection === '9' ? classes.selected : ''} ${classes.unsetTextTransform}`}
                                >
                                9
                            </Button>
                            <Button
                                onClick={() => onHoleChange({ target: { value: '18'}})}
                                variant={holeCountSelection === '18' ? 'contained' : 'flat'}
                                classes={classOverides} disabled={holeCountSelection === '18'}
                                className={`${classes.button} ${holeCountSelection === '18' ? classes.selected : ''} ${classes.unsetTextTransform}`}
                                >
                                18
                            </Button>
                    </div>
                </ExpansionPanelDetails>
            </ExpansionPanel>
            <Divider />
            <ExpansionPanel elevation={0} expanded={this.state.showCart} onChange={this.handleExpandCart} className={classes.expantionPanel}>
                <ExpansionPanelSummary
                    expandIcon={<ChevronDown   viewBox="0 0 24 13" className={classes.expand} />}
                    IconButtonProps={{ disableRipple: true }}
                >
                     <div>
                        <Typography className={`${classes.headers} ${classes.semiBold}`}>Golf Cart</Typography>
                        <Typography className={classes.subNoteHeader}>{
                            golfCartSelection === '1'
                            ? 'Included'
                            : golfCartSelection === '2'
                            ?  'No Golf Cart'
                            : 'Any'
                            }</Typography>
                    </div>
                </ExpansionPanelSummary>
                <ExpansionPanelDetails className={classes.expansion}>
                    <div style={{ display: 'flex' }}>
                            <Button
                                onClick={() => onCartChange({ target: { value: '0'}})}
                                variant={golfCartSelection === '0' ? 'contained' : 'flat'}
                                classes={classOverides} disabled={golfCartSelection === '0'}
                                className={`${classes.button} ${golfCartSelection === '0' ? classes.selected : ''} ${classes.unsetTextTransform}`}
                            >
                                Any
                            </Button>
                            <Button
                                onClick={() => onCartChange({ target: { value: '1'}})}
                                variant={golfCartSelection === '1' ? 'contained' : 'flat'}
                                classes={classOverides}
                                disabled={golfCartSelection === '1'}
                                className={`${classes.button} ${golfCartSelection === '1' ? classes.selected : ''} ${classes.unsetTextTransform}`}
                                >
                                Included
                            </Button>
                            <Button
                                onClick={() => onCartChange({ target: { value: '2'}})}
                                variant={golfCartSelection === '2' ? 'contained' : 'flat'}
                                classes={classOverides} disabled={golfCartSelection === '2'}
                                className={`${classes.button} ${golfCartSelection === '2' ? classes.selected : ''} ${classes.unsetTextTransform}`}
                                >
                                No Golf Cart
                            </Button>
                    </div>
                </ExpansionPanelDetails>
            </ExpansionPanel>
            <Divider />
      </div>
    );
  }
}


/**
 *   This has a lot of unused styling classes
 */
const styles = theme => {
  /**
   * there is a bug for material - ui controlled Input components that are
   * contained in formcontrol that causes an infinite setState loop when multiple input
   * componets are children for the same formControl component and the value
   * for one of the Input components is an empty string. So I am importing the styles for Input and injecting them into a class for
   * use with native input components.
   */
  const {
    root,
    input
  } = InputStyles(theme);
  const inputStyles = merge(omit(['font', 'color', '&$disabled'], input), pick(['fontSize', 'color', 'fontFamily'], root))
  return ({
    buttonContainer: {
      display: 'flex',
      flexWrap: 'wrap',
    },
    headline: {
      paddingBottom: '10px',
      [theme.breakpoints.down('sm')]: {
        padding: '0 25px 15px',
        fontSize: '14px',
        fontWeight: '600',
        borderBottom: `1px solid #d5d8db`
      }
    },
    headers: {
      fontSize: '16px',
      color: theme.grouponBlack,
    },
    formControl: {
      marginTop: '35px'
    },
    group: {
      margin: `${theme.spacing.unit}px 0`,
      [theme.breakpoints.down('sm')]: {
        padding: '0 20px'
      }
    },
    formLabel: {
      minWidth: '250px',
      paddingBottom: '10px',
      color: theme.palette.common.black,
      [theme.breakpoints.down('sm')]: {
        marginBottom: '10px',
        marginLeft: '20px'
      }
    },
    formLabelSliders: {
      paddingBottom: '20px',
      minWidth: '250px',
      color: theme.palette.common.black,
      [theme.breakpoints.down('sm')]: {
        padding: '20px'
      }
    },
    formControlLabel: {
      maxHeight: '35px'
    },
    border: {
      border: `1px solid ${theme.palette.secondary.light}`,
      borderRadius: '2px'
    },
    borderLeft: {
      border: `1px solid ${theme.palette.secondary.light}`,
      borderRadius: '2px'
    },
    slider: {
      margin: '20px 0',
      [theme.breakpoints.down('sm')]: {
        margin: '20px 20px',
        width: '80%'
      }
    },
    sliderSymbols: {
      marginTop: '8px',
      textAlign: 'center',
      color: theme.palette.secondary.dark
    },
    subNote: {
      color: theme.palette.secondary.dark,
      paddingBottom: '10px',
      marginLeft: '15px'
    },
    subNoteHeader: {
        color: theme.palette.secondary.dark,
    },
    dividerHide: {
      [theme.breakpoints.down('sm')]: {
        display: 'none'
      }
    },
    filterIcon: {
      display: 'none',
      [theme.breakpoints.down('sm')]: {
        display: 'inline-flex',
        height: '20px',
        float: 'right'
      }
    },
    priceWrapper: {
      [theme.breakpoints.down('sm')]: {
        padding: '10px',
        paddingRight: '55px'
      }
    },
    reset: {
      [theme.breakpoints.down('sm')]: {
        // padding: '8px 75px',
        width: '100%',
        margin: theme.spacing.unit,
        borderRadius: 0,
        borderColor: theme.palette.primary.main
      }
    },
    apply: {
      [theme.breakpoints.down('sm')]: {
        // padding: '8px 75px',
        width: '100%',
        margin: theme.spacing.unit,
        borderRadius: 0,
        color: theme.palette.common.white,
        backgroundColor: theme.palette.primary.main
      }
    },
    padding: {
      padding: '20px'
    },
    gridContainer: {
      flexGrow: 1,
      padding: '20px',
      paddingRight: '60px'
    },
    semiBold: {
      fontWeight: 600
    },
    input: merge(inputStyles, { padding: '10px'}),
    expand: {
        color: theme.palette.primary.main,
        fontSize: '20px'
    },
    expantionPanel: {
        margin: '0px'
    },
    expansion: {
        display: 'inherit',
        padding: 0,
        paddingLeft: '10px',
        borderTop: '2px solid #EDEDED',
        backgroundColor: theme.palette.secondary.main,
        [theme.breakpoints.down('sm')]: {
            borderTop: '1px solid #d5d8db'
        },
    },
    buttonContained: {
        '&$disabled': {
          color: '#fff',
          backgroundColor: theme.palette.primary.main,
          '&:hover': {
            backgroundColor: theme.palette.primary.main
          }
        },
        '&:hover': {
          backgroundColor: theme.palette.primary.main
        }
      },
      buttonRoot: {
        '&:hover': {
          color: '#fff',
          backgroundColor: theme.palette.primary.main
        }
      },
      button: {
        minWidth: 'auto',
        margin: theme.spacing.unit,
        color: theme.grouponBlack,
        backgroundColor: '#fff',
        border: `1px solid ${theme.palette.secondary.light}`
      },
      selected: {
        backgroundColor: theme.palette.primary.main,
        color: theme.palette.secondary.light
      },
      disabled: {},
      unsetTextTransform: {
        textTransform: 'none'
      }
  })
};

export default withStyles(styles)(AdvancedFiltersMobile);



// WEBPACK FOOTER //
// ./src/components/AdvancedFiltersMobile/index.js